const vooMainProduct = document.querySelector('.voo-main-product');
const vooStartsetWrapper = document.querySelector('.voo-starterset__wrapper');
const vooStartsetButtonWrapper = document.querySelector('.voo-startset-button__wrapper');
const vooStartsetButtonFirstStep = document.querySelector('#voo-startset-button__first-step');
const vooStartsetButtonLastStep = document.querySelector('.voo-startset-button__last-step');
const vooStartsetProduct = document.querySelector('.voo-startset__product');
const vooStartsetButtonCheckout = document.getElementById('voo-startset-button__checkout');
const inputs = document.querySelectorAll('.product-form__input input[type="radio"]');
const vooOptinValue = document.getElementById('voo-startset-product__option-value');
const freeBlocks = document.querySelectorAll('.voo-free-block__item');

let startsetProductContent = document.querySelector('.voo-startset-product__content');

let vooCheckedValue;
let totalProduct;
let vooSelectedProducts = [];

function mobileScroll() {
  if (window.innerWidth < 768) {
    const productMediaWrapper = document.querySelector('.product__media-wrapper');
    const productText = document.querySelector('.product__text');
    const productTitle = document.querySelector('.product__title');
    const shopifyRatingBlock = document.querySelector('#shopify-block-okendo_star_rating_HKDQgX');

    if (productMediaWrapper) {
      productMediaWrapper.classList.toggle('voo-startset--hidden');
    }

    if (productText) {
      productText.classList.toggle('voo-startset--hidden');
    }

    if (productTitle) {
      productTitle.classList.toggle('voo-startset--hidden');
    }

    if (shopifyRatingBlock) {
      shopifyRatingBlock.classList.toggle('voo-startset--hidden');
    }

    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }
}

function hideSection() {
  const mainContent = document.getElementById('MainContent');
  const vooFooter = document.querySelector('.voo-footer');

  if (mainContent) {
    const shopifySection = MainContent.querySelectorAll('.shopify-section');

    if (shopifySection) {
      shopifySection.forEach((section, index) => {
        if (index !== 0) {
          section.classList.toggle('voo-startset--hidden');
        }
      });
    }
  }

  if (vooFooter) {
    vooFooter.classList.toggle('voo-startset--hidden');
  }
}

function startsetGiftCount() {
  if (inputs) {
    inputs.forEach((input) => {
      if (input.checked) {
        const freeGiftValue = input.getAttribute('data-free-gift');

        if (freeBlocks.length > 0) {
          freeBlocks.forEach((block) => {
            const blockNumber = block.classList[1].split('--')[1];

            if (parseInt(blockNumber) <= parseInt(freeGiftValue)) {
              block.classList.remove('voo-free-block__item--lock');
            } else {
              block.classList.add('voo-free-block__item--lock');
            }
          });
        }
      }
    });
  }
}

function inputChecked() {
  const startsetVariants = vooMainProduct.querySelectorAll('.voo-startset-variant input');

  startsetVariants.forEach((variant) => {
    if (variant.checked) {
      vooCheckedValue = variant.value.replace('Flaschen', window.vooStartset.bottles).replace('Flasche', window.vooStartset.bottle);
    }
  });
}

function totalQuantity() {
  inputChecked();

  const activeElements = document.querySelectorAll('.voo-startset-options__add.active .quantity');

  const totalQuantity = Array.from(activeElements).reduce((total, div) => {
    const quantity = parseInt(div.textContent.trim(), 10);
    return total + quantity;
  }, 0);

  const countVariantProduct = parseInt(vooCheckedValue.match(/\d+/)[0]);
  totalProduct = countVariantProduct - totalQuantity;

  if (totalProduct <= 0) {
    vooStartsetButtonCheckout.innerHTML = `${window.vooStartset.button_checkout} <span class="voo-startset__button--arrow"></span>`;
    vooStartsetButtonCheckout.disabled = false;
  } else if (totalProduct <= countVariantProduct && totalProduct > 1) {
    vooStartsetButtonCheckout.innerHTML = `${window.vooStartset.choose_yet} ${totalProduct} ${window.vooStartset.bottles}`;
    vooStartsetButtonCheckout.disabled = true;
  } else if (totalProduct == 1) {
    vooStartsetButtonCheckout.innerHTML = `${window.vooStartset.choose_yet} 1 ${window.vooStartset.bottle}`;
    vooStartsetButtonCheckout.disabled = true;
  }

  if (freeBlocks.length > 0) {
    freeBlocks.forEach((block) => {
      const blockNumber = block.classList[1].split('--')[1];

      if (totalQuantity >= countVariantProduct) {
        if (2 <= totalQuantity && parseInt(blockNumber) <= totalQuantity) {
          block.classList.remove('voo-free-block__item--lock');
        } else {
          block.classList.add('voo-free-block__item--lock');
        }
      }
    });
  }
}

function handleAddButtonClick(event) {
  const vooStartsetOptionAddButton = event.target.closest('.voo-startset-options__add');

  if (vooStartsetOptionAddButton) {
    const vooQuantity = vooStartsetOptionAddButton.querySelector('.quantity');
    const vooProductButton = vooStartsetOptionAddButton.querySelector('.product-button');
    const vooStartsetOptionQuantity = vooStartsetOptionAddButton.querySelector('#voo-startset-options__quantity');

    if (event.target.classList == 'product-button') {
      vooStartsetOptionAddButton.classList.add('active');

      totalQuantity();
    }

    if (event.target.classList == 'plus') {
      vooQuantity.textContent = parseInt(vooQuantity.textContent) + 1;
      totalQuantity();
    } else if (event.target.classList.contains('minus')) {
      vooQuantity.textContent = parseInt(vooQuantity.textContent) - 1;
      totalQuantity();

      if (vooQuantity.textContent == 0) {
        vooQuantity.textContent = 1;
        vooStartsetOptionAddButton.classList.remove('active');
        totalQuantity();
      }
    }
  }
}

function addProducts() {
  const activeStartsetOptions = document.querySelectorAll('.voo-startset-options__add.active');
  activeStartsetOptions.forEach((option) => {
    const productIdInput = option.querySelector('.voo-startset__product-id');
    const quantityInput = option.querySelector('.quantity');

    if (productIdInput && quantityInput) {
      const productId = productIdInput.value;
      const quantity = parseInt(quantityInput.textContent.trim(), 10);

      vooSelectedProducts.push({
        id: productId,
        properties: {
          _startset: 'startset',
        },
        quantity: quantity,
      });
    }
  });
}

function addToGiftProducts() {
  const freeBlocks = document.querySelectorAll(
    '.voo-free-block__item:not(.voo-free-block__item--lock) input[type="text"]'
  );

  freeBlocks.forEach((block) => {
    const valueId = block.value;
    vooSelectedProducts.push({
      id: valueId,
      properties: {
        _startset: 'startset',
      },
      quantity: 1,
    });
  });
}

function saveLocalStorage() {
  localStorage.setItem('startset', 'active');
  localStorage.setItem('reload', 'true');
  const products = {};

  startsetProductContent.querySelectorAll('.voo-startset-options__add.active:not(.disabled)').forEach(activeProduct => {
    const productId = activeProduct.dataset.productId;
    products[productId] = parseInt(activeProduct.querySelector('.quantity').textContent) || 0;
  });
  localStorage.setItem('vooStartsetProduct', JSON.stringify(products));
}

if (localStorage.getItem('reload') == 'true') {
  localStorage.setItem('reload', 'false');
  location.reload();
} else {
  if (localStorage.getItem('startset') == 'active') {
    vooStartsetWrapper.style.height = vooStartsetProduct.offsetHeight + 'px';
    vooStartsetProduct.classList.toggle('voo-startset__product--active');
    vooStartsetButtonFirstStep.classList.toggle('voo-startset--hidden');
    vooStartsetButtonLastStep.classList.toggle('voo-startset--hidden');
    vooStartsetButtonWrapper.classList.toggle('voo-startset-button--sticky');

    startsetGiftCount();
    setTimeout(() => {
      totalQuantity();
      vooOptinValue.innerHTML = vooCheckedValue;
    }, 500);

    const products = JSON.parse(localStorage.getItem('vooStartsetProduct')) || {};
    startsetProductContent.querySelectorAll('.voo-startset-options__add:not(.disabled)').forEach(product => {
      const productId = product.dataset.productId;
      if (products[productId] !== undefined) {
        product.classList.add('active');
        const quantity = product.querySelector('.quantity');
        if (quantity) {
          quantity.textContent = products[productId];
        }
      }
    });

    mobileScroll();
    hideSection();
  } else {
    setTimeout(() => {
      startsetGiftCount();
      totalQuantity();
    }, 500);
  }
}

if (vooMainProduct) {
  window.addEventListener('resize', () => {
    if (vooStartsetProduct.classList.contains('voo-startset__product--active')) {
      vooStartsetWrapper.style.height = vooStartsetProduct.offsetHeight + 'px';
    }
  });

  vooMainProduct.addEventListener('click', (event) => {
    if (event.target.tagName === 'INPUT' && event.target.type === 'radio') {
      if (event.target.value !== undefined) {
        document.querySelectorAll('.voo-startset-options__add.active').forEach((element) => {
          const quantityElement = element.querySelector('.quantity');

          if (quantityElement) {
            quantityElement.textContent = '1';
          }

          element.classList.remove('active');
        });

        vooCheckedValue = event.target.value;
        vooStartsetButtonCheckout.innerHTML = `${window.vooStartset.choose_yet} ${vooCheckedValue}`;
        startsetGiftCount();
        totalQuantity();
      }
    }

    if (event.target.id == 'voo-startset-button__first-step') {
      vooStartsetWrapper.style.height = vooStartsetProduct.offsetHeight + 'px';
      vooStartsetProduct.classList.toggle('voo-startset__product--active');
      vooStartsetButtonFirstStep.classList.toggle('voo-startset--hidden');
      vooStartsetButtonLastStep.classList.toggle('voo-startset--hidden');
      vooStartsetButtonWrapper.classList.toggle('voo-startset-button--sticky');
      vooOptinValue.innerHTML = vooCheckedValue;
      vooStartsetButtonCheckout.innerHTML = `${window.vooStartset.choose_yet} ${vooCheckedValue}`;

      mobileScroll();
      hideSection();
    }

    if (event.target.classList == 'voo-startset-product__prev') {
      vooStartsetWrapper.style.height = 'auto';
      vooStartsetProduct.classList.toggle('voo-startset__product--active');
      vooStartsetButtonFirstStep.classList.toggle('voo-startset--hidden');
      vooStartsetButtonLastStep.classList.toggle('voo-startset--hidden');
      vooStartsetButtonWrapper.classList.toggle('voo-startset-button--sticky');

      mobileScroll();
      hideSection();

      localStorage.removeItem('vooStartsetProduct');
      localStorage.removeItem('startset');
      localStorage.removeItem('reload');
    }

    handleAddButtonClick(event);

    if (event.target.id == 'voo-startset-button__checkout') {
      startsetProductContent = document.querySelector('.voo-startset-product__content');

      addProducts();
      addToGiftProducts();
      saveLocalStorage();

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: vooSelectedProducts,
        }),
      })
        .then(function (response) {
          if (response.ok) {
            window.location.href = '/checkout';
          } else {
            console.error('Error adding an item to the cart:', response.statusText);
          }
        })
        .catch(function (error) {
          console.error('Error adding an item to the cart:', error);
        });
    }
  });
}

if (window.innerWidth < 768) {
  const button = document.createElement('button');
  button.className = 'voo-startset__button voo-startset-button--sticky';
  button.id = 'voo-startset-button__fixed';
  button.innerHTML = `
    ${window.vooStartset.first_step_btn}
    <svg viewBox="0 0 14 10" fill="none" aria-hidden="true" focusable="false" class="icon icon-arrow" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z" fill="currentColor"></path>
    </svg>
`;

  document.body.appendChild(button);

  const checkPosition = () => {
    if (vooStartsetButtonFirstStep) {
      const rect = vooStartsetButtonFirstStep.getBoundingClientRect();
      const topPosition = rect.top + window.scrollY;
      const currentScroll = window.scrollY || document.documentElement.scrollTop;

      if (currentScroll > topPosition) {
        button.classList.remove('voo-startset--hidden');
      } else {
        button.classList.add('voo-startset--hidden');
      }
    }
  };

  button.addEventListener('click', () => {
    vooStartsetWrapper.style.height = vooStartsetProduct.offsetHeight + 'px';
    vooStartsetProduct.classList.toggle('voo-startset__product--active');
    vooStartsetButtonFirstStep.classList.toggle('voo-startset--hidden');
    vooStartsetButtonLastStep.classList.toggle('voo-startset--hidden');
    vooStartsetButtonWrapper.classList.toggle('voo-startset-button--sticky');
    vooOptinValue.innerHTML = vooCheckedValue;
    vooStartsetButtonCheckout.innerHTML = `${window.vooStartset.choose_yet} ${vooCheckedValue}`;

    mobileScroll();
    hideSection();
  });

  window.addEventListener('scroll', checkPosition);
  window.addEventListener('resize', checkPosition);

  checkPosition();
}
